import { render, staticRenderFns } from "./Authentications.vue?vue&type=template&id=d04c87ea&"
import script from "./Authentications.vue?vue&type=script&lang=js&"
export * from "./Authentications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports